<div class="flex overflow-hidden h-full">
    <cac-dialog-layout [title]="data.role ? 'ویرایش نقش' : 'اضافه کردن نقش'"
        [subtitle]="'مشخصات و اطلاعات پایه نقش را وارد کنید'" [form]="baseForm.formGroup" [permission]="!!data.role ? 'EditRole' : undefined" (onSubmit)="onSubmit($event)">
        <cac-form-builder [options]="baseForm"></cac-form-builder>
    </cac-dialog-layout>

    <div class="bg-surface pt-6 py-9 px-11 flex flex-col flex-auto overflow-hidden w-full">
        <div class="flex flex-col">
            <p class="text-surface-on text-sm mt-2">دسترسی های مجاز برای نقش را انتخاب کنید.</p>
        </div>

        <cac-field class="mt-5" placeholder="جستجو در دسترسی ها" label="جستجو" floatLabel="always" prefixIcon="search"
            [control]="searchControl" [clearable]="true"></cac-field>

        <div class="overflow-auto flex-1 flex flex-col gap-6 mt-1 pb-12">

            @for (group of filteredGroups(); track group.label) {
            <div class="flex flex-col gap-4">
                @if(group.permissions.length) {
                <p class="text-base select-none">{{group.label}}</p>
                }
                @for (permission of group.permissions; track $index) {
                <app-permission-box [data]="permission"></app-permission-box>
                }
            </div>
            }
        </div>
    </div>
</div>